import _ from 'lodash';
import { apiFetch } from '../utility';

const apiBase = 'pricingRequest';
const PRICING_REQUEST_RESULT = 'retailPricing/pricingRequest/SEARCH/';
const PRICING_REQUEST_STATUS_CHANGE = 'retailPricing/pricingRequest/CHANGE';

const initialState = {
	byStationId: {},
	byStatus: {},
};

export default (state = initialState, action) => {
	if (action.type === PRICING_REQUEST_RESULT) {
		if (action.stationId) {
			return {
				...state,
				byStationId: {
					...state.byStationId,
					[action.stationId]: _.map(action.pricingRequests, 'pricingRequestId'),
				},
			};
		} else if (action.status) {
			return {
				...state,
				byStatus: {
					...state.byStatus,
					[action.status]: _.map(action.pricingRequests, 'pricingRequestId'),
				},
			};
		} else {
			return state;
		}
	} else if (action.type === PRICING_REQUEST_STATUS_CHANGE) {
		const { status, pricingRequestId } = action.pricingRequest;

		const pendingIds = _.get(state, ['byStatus', 'pending'], []);
		const triageIds = _.get(state, ['byStatus', 'triage'], []);
		const invalidIds = _.get(state, ['byStatus', 'invalid'], []);
		const issuedIds = _.get(state, ['byStatus', 'issued'], []);
		//if (!pendingIds || !issuedIds) {
		//return state;
		//}
		//
		//- New triage invoice. Means we have a new invoice
		if (status === 'triage') {
			const newTriageIds = _.uniq(triageIds.concat([pricingRequestId]));
			return {
				...state,
				byStatus: {
					...state.byStatus,
					triage: newTriageIds,
				},
			};
		}

		//- New pending invoice. Means we have a new invoice
		if (status === 'pending') {
			const newPendingIds = _.uniq(pendingIds.concat([pricingRequestId]));
			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
				},
			};
		}

		//- New invalid invoice. Means we have a new invoice
		if (status === 'invalid') {
			const newInvalidIds = _.uniq(invalidIds.concat([pricingRequestId]));
			const newTriageIds = _.filter(triageIds, (id) => {
				return id !== pricingRequestId;
			});
			const newPendingIds = _.filter(pendingIds, (id) => {
				return id !== pricingRequestId;
			});

			return {
				...state,
				byStatus: {
					...state.byStatus,
					triage: newTriageIds,
					pending: newPendingIds,
					invalid: newInvalidIds,
				},
			};
		}

		if (status === 'issued') {
			const newIssuedIds = _.uniq(issuedIds.concat([pricingRequestId]));
			const newTriageIds = _.filter(triageIds, (id) => {
				return id !== pricingRequestId;
			});
			const newPendingIds = _.filter(pendingIds, (id) => {
				return id !== pricingRequestId;
			});

			return {
				...state,
				byStatus: {
					...state.byStatus,
					triage: newTriageIds,
					pending: newPendingIds,
					issued: newIssuedIds,
				},
			};
		}
	} else {
		return state;
	}
};

export const search = (p) => {
	const { status, stationId, afterDate, callback = _.noop } = p;

	return (dispatch) => {
		const params = {
			status,
			afterDate,
			stationId,
		};

		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback: (err, r) => {
				if (err) {
					return callback(err);
				}

				const pricingRequests = _.get(r, ['collections', 'pricingRequestCollection']);
				dispatch({
					type: PRICING_REQUEST_RESULT,
					status,
					stationId,
					pricingRequests,
				});
				callback();
			},
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const publicGet = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.public.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const publicSubmitPricing = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.public.submitPricing`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			callback,
		});
	};
};

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const invalidate = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.invalidate`,
			params,
			dispatch,
			successMessage: `Pricing request invalidated`,
			callback: (err, r) => {
				if (err) {
					return callback(err);
				}
				const pricingRequest = _.get(r, ['collections', 'pricingRequestCollection', 0]);

				dispatch({
					type: PRICING_REQUEST_STATUS_CHANGE,
					pricingRequest,
				});
				callback();
			},
		});
	};
};
